var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
      'background-color': _vm.bgColor,
    }),attrs:{"id":_vm.$options.name}},[_c('vue-headful',{attrs:{"title":_vm.$t('browser-tab-title')}}),_c('router-view'),_c('app-snackbar',{ref:"snackbar"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }